import type { TableColumnConfig } from '../../../data/table-column-config';
import { DateCellComponent } from './date-cell.component';

export function createDateColumn<T>(
  fieldId: string,
  fieldName: keyof T,
  labelI18nKey: string,
  sortable = false,
): TableColumnConfig<T> {
  return {
    id: fieldId,
    field: fieldName,
    label: labelI18nKey,
    cellContent: DateCellComponent,
    sortable,
  };
}
